export default __webpack_public_path__ + "static/media/109.76a6b2df.jpeg";